import React from "react";
import { Redirect } from "react-router-dom";
import Form from "./common/form";
import auth from "../services/authService";
import { Typography } from "@material-ui/core";

export class ForgotPasswordForm extends Form {
    state = {
        message: "",
        data: { email: "" },
        errors: {},
        error: ""
    };

    doSubmit = async () => {
        try {
            const { data } = this.state;
            const response = await auth.requestRequestForgotPasswordEmail(data.email);
            if(response.data.status == "error") {
                this.setState({ error: response.data.message || "Átmeneti hiba, kérjük próbálja meg pár perc múlva!" });
                this.setState({ message: "" });
            } else {
                this.setState({ message: "A jelszó helyreállításához szükséges információkat e-mailben elküldtük!" });
                this.setState({ error: "" });
            }
        } catch (ex) {
            this.setState({ error: "Átmeneti hiba, kérjük próbálja meg pár perc múlva!" });
        }
    };

    render() {
        return (
            <div>
                <h1>Elfelejtett jelszó</h1>

                {this.state.message === "" ? null : (<Typography color="primary">{this.state.message}</Typography>)}

                {this.state.error === "" ? null : (<Typography color="error">{this.state.error}</Typography>)}
                <form onSubmit={this.handleSubmit}>
                    {this.renderInput("email", "E-mail")}
                    <br />
                    {this.renderButton("Új jelszó kérés")}
                </form>
            </div>
        );
    }
}

export default ForgotPasswordForm;
